<template>
  <v-card>
    <v-card-title>
      Select a Campaign to Copy
    </v-card-title>
    <v-card-text>
      <p>Copy a campaign from any dealer. If dealer is not the same as current dealer, datasource, email sender and email template are not copied</p>
      <v-form ref="copyCampaignForm">
        <dealer-select-standalone
          v-model="dealerId"
          :dealer_id="dealerId"
          :modify-vuex-dealer="false"
          required
        >
        </dealer-select-standalone>

        <email-campaign-select
          v-model="campaignId"
          :dealer_id="dealerId"
          label="Select and existing Email Campaign"
          v-on:selected-email-campaign="onEmailCampaignChange"
        >
        </email-campaign-select>

      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
      <v-btn color="blue darken-1" text @click="copy()">Copy</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DealerSelectStandalone, EmailCampaignSelect } from '@/components/inputs'
import { EmailCampaignApi } from '@/services'

export default {
  name: 'copy-campaign-dialog',
  components: {
    [DealerSelectStandalone.name]: DealerSelectStandalone,
    [EmailCampaignSelect.name]: EmailCampaignSelect
  },
  props: {
    initialDealerId: {
      required: false,
      type: [Number, String]
    }
  },
  data () {
    return {
      dealerId: null,
      campaignId: null,
      campaign: {}
    }
  },
  computed: {
  },
  watch: {

  },
  methods: {
    close () {
      this.$emit('close')
    },
    copy () {
      // call server side to build campaign
      EmailCampaignApi.copyFrom(this.campaignId, this.initialDealerId)
        .then(resp => {
          this.$emit('on-copy', resp.data)
        })
        .catch(error => {
          this.$flash({
            showClose: true,
            message: 'Error copying campaign. ' + error.message,
            type: 'error'
          })
        })
    },
    onEmailCampaignChange (campaign) {
      this.campaign = campaign
    }
  },
  mounted () {
    if (this.initialDealerId) {
      this.dealerId = this.initialDealerId
    }
  }
}
</script>
